import { render, staticRenderFns } from "./netteach-details.vue?vue&type=template&id=f7b9b98e"
import script from "./netteach-details.vue?vue&type=script&lang=js"
export * from "./netteach-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports